export default {
  bind(el, binding, vnode) {
    const dialogHeaderEl = el.querySelector('.el-dialog__header')
    const dragDom = el.querySelector('.el-dialog')
    dialogHeaderEl.style.cssText += ';cursor:move;'
    const dragDomRect = dragDom.getBoundingClientRect()
    dragDom.style.cssText += `;margin-top:0px;left:${dragDomRect.left}px;top:${dragDomRect.top}px;`

    const viewportPadding = 20

    dialogHeaderEl.onmousedown = (e) => {
      const currentRect = dragDom.getBoundingClientRect()
      const disX = e.clientX - currentRect.left
      const disY = e.clientY - currentRect.top
      const dragDomWidth = dragDom.offsetWidth
      const screenWidth = document.documentElement.clientWidth
      const screenHeight = document.documentElement.clientHeight
      const minLeft = viewportPadding
      const maxLeft = Math.max(screenWidth - dragDomWidth - viewportPadding, minLeft)
      const minTop = viewportPadding
      const maxTop = Math.max(screenHeight - dialogHeaderEl.offsetHeight - viewportPadding, minTop)

      document.onmousemove = function(e) {
        let left = e.clientX - disX
        let top = e.clientY - disY
        left = Math.min(Math.max(left, minLeft), maxLeft)
        top = Math.min(Math.max(top, minTop), maxTop)

        dragDom.style.cssText += `;left:${left}px;top:${top}px;`

        vnode.child.$emit('dragDialog')
      }

      document.onmouseup = function() {
        document.onmousemove = null
        document.onmouseup = null
      }
    }
  }
}
